import { PUBLISHER_ID_CASA_DUARTE } from './constants/constants'

const publisherUtils = {
  isCasaDuartePublisher(publisherID) {
    return publisherID && publisherID === PUBLISHER_ID_CASA_DUARTE
  },
}

export default publisherUtils
